<template>
    <div
        class="pb-1"
        :class="{
            'border-b border-b-gray-200': withBorder,
        }"
    >
        <span
            class="text-xs font-semibold uppercase text-gray-500 flex items-center gap-2"
        >
            <Icon
                v-if="iconName"
                :name="iconName"
                class="text-gray-500 w-3.5 h-3.5"
            />
            <slot />
        </span>
    </div>
</template>

<script setup lang="ts">
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        iconName: {
            type: String,
            default: null,
        },
        withBorder: {
            type: Boolean,
            default: true,
        },
    })
</script>
